import React, { useState } from "react";
import AddInventoryModal from "./AddInventoryModal";
import { can, Permissions } from "../auth/authorization";

function ProductDetails({ product, onClose }) {
  const [openAddInventory, setOpenAddInventory] = useState(false);

  const formatCurrency = (v) => {
    if (v === null || v === undefined) return "?0.00";
    // remove any non-numeric characters (commas, currency symbols, replacement chars, question marks)
    const s = String(v).replace(/[^0-9.-]+/g, "");
    const num = Number(s);
    if (Number.isNaN(num)) return "?0.00";
    return `?${num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  };

  if (!product) return null;

  return (
    <>
      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white rounded-lg shadow-lg w-11/12 sm:w-3/4 md:w-1/2 p-6 relative">
          <h2 className="text-lg font-bold mb-4 text-gray-800">Product Details</h2>

          <div className="space-y-3 text-sm">
            <p><span className="font-semibold text-gray-700">Name:</span> {product.name}</p>
            <p><span className="font-semibold text-gray-700">Vendor:</span> {product.vendor}</p>
            <p><span className="font-semibold text-gray-700">Category:</span> {product.category}</p>
            <p><span className="font-semibold text-gray-700">Stock:</span> {product.stock}</p>
            <p><span className="font-semibold text-gray-700">Description:</span> {product.description}</p>
            <p><span className="font-semibold text-gray-700">Purchase Cost:</span> {formatCurrency(product.purchaseCost)}</p>
            <p><span className="font-semibold text-gray-700">Sales Price:</span> {formatCurrency(product.salePrice)}</p>
            <p>
              <span className="font-semibold text-gray-700">Availability:</span>{" "}
              {product.stock > 0 ? (
                <span className="text-green-600 font-medium">In Stock</span>
              ) : (
                <span className="text-red-600 font-medium">Out of Stock</span>
              )}
            </p>
          </div>

          {/* Bottom action buttons */}
          <div className="flex justify-end gap-3 mt-6">
            {can(Permissions.Add) && (
              <button
                onClick={() => setOpenAddInventory(true)}
                className="px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-md text-sm"
              >
                + Add Inventory
              </button>
            )}

            <button
              onClick={onClose}
              className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md text-sm"
            >
              Close
            </button>
          </div>
        </div>
      </div>

      {/* Show AddInventory modal */}
      {openAddInventory && can(Permissions.Add) && (
        <AddInventoryModal
          product={product}
          onClose={() => setOpenAddInventory(false)}
          onSaved={() => window.location.reload()}
        />
      )}
    </>
  );
}

export default ProductDetails;
